module.exports = __webpack_public_path__ + "img/by.8ed77d9d.svg";